import { render, staticRenderFns } from "./fund-source-list.vue?vue&type=template&id=45516ba0&"
import script from "./fund-source-list.vue?vue&type=script&lang=js&"
export * from "./fund-source-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports